import type { ProseBlockModel } from '@site/shared'
import { LexicalRender } from '@/components/ui/LexicalRender'

/** Long-form rich text (about text, legal/policy pages), left-aligned in a
 *  readable measure. */
export function ProseSection({ block }: { block: ProseBlockModel }) {
  return (
    <section className="block">
      <div className="wrap wrap-narrow">
        {block.heading && <h1 className="h1">{block.heading}</h1>}
        <LexicalRender data={block.body} />
      </div>
    </section>
  )
}
